<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="12">
                <rkm-form-input-autocomplete
                    :searchFields="localForm.autocompleteFields.usuario"
                    :repository="repositories.usuario"
                    text-field="cidadaoNome"
                    v-model="supervisor.usuario"
                    :validations="validations.usuario"
                    label="Supervisor"
                    uppercase
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { object, repository } from '@/mixins'

export default {

    computed: {
        validations() {

            return {
                usuario: { required: true },
            }
        },
        hasIndex() {

            return this.index !== null
        },
    },
   created() {

        this.repositories = {
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
        }
    },
    data: () => ({
        localForm: {
            autocompleteFields: {
                usuario: [
                    { key: "cadastroCidadao.nome", searchable: true },
                ],
            },
        },
        supervisor: {
            id: null,
            nome: null,
            usuarioId: null
        },
    }),
   methods: {
        save() {

            this.$refs.Form.validate()
                 .then(valid => {

                    if (!valid) return

                        const supervisor = this.clone(this.supervisor)

                            if (this.hasOcupacaoParametrizada(supervisor.usuario.id)) {

                                this.resetForm()

                                this.showValidationNotification("Já existe um registro com esse supervisor.")
                                return
                            }

                        this.supervisor.id = this.uniqueId('supervisor' + new Date().getTime())

                        const param = {
                            id: this.supervisor.id,
                            nome: supervisor.usuario.cidadaoNome,
                            usuarioId: supervisor.usuario.id,
                        }

                        if (this.hasIndex) {

                            this.$set(this.data.model.supervisores, this.index, this.clone(param))
                        }
                        else {

                            this.data.model.supervisores.push(this.clone(param))
                        }

                        this.$emit('save', this.clone(param))
                })
        },
        hasOcupacaoParametrizada(usuario) {

            return this.data.model.supervisores.find(supervisor => supervisor.usuarioId === usuario)
        },
        resetForm() {

            this.supervisor.usuario = null
            this.$nextTick(() => this.$refs.Form.resetValidator())
        },
    },
    mixins: [object, repository],
    props: {
        data: { type: Object, required: true },
        index: { type: Number, default: null },
        item: { type: Object, default: null },
    },
}
</script>